module.exports = __webpack_public_path__ + "img/blog-13-1.19cc0b67.webp";